import { REPORTS_ENDPOINT } from "../../constants";
import { baseApi } from "./base.api.required.stub";
export const vulnerabilitiesApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getVulnerabilities: build.query({
            // matchFulfilled only fires on real fetches, not cache hits. Without keepUnusedDataFor=0,
            // extraReducer matchers (e.g. auto-expand on single-match filters) silently
            // skip on re-navigation because RTK Query serves cached data instead of fetching.
            keepUnusedDataFor: 0,
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/vulnerabilities`,
                params: data,
            }),
        }),
        getVulnerabilityReferences: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/vulnerabilities/${data.ui_item_id}/references`,
                params: data,
            }),
        }),
        getVulnerabilityCveList: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/vulnerabilities/cve-list`,
            }),
        }),
        getVulnerabilityReferenceNames: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/vulnerabilities/references`,
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useGetVulnerabilitiesQuery, useGetVulnerabilityReferencesQuery, useLazyGetVulnerabilityCveListQuery, useLazyGetVulnerabilityReferenceNamesQuery, } = vulnerabilitiesApi;
//# sourceMappingURL=vulnerabilities.api.js.map